import React, { useEffect } from 'react'
import { useDispatch } from "react-redux";
import { makeStyles, Box, Container, Typography } from "@material-ui/core";
import { useParams } from "react-router-dom";
import { startAlerta } from "../../../actions/ui/alertas";
import { finishSpinner, startSpinner } from "../../../actions/ui/spinner";
import AfiliadoTurnosService from "../../../services/AfiliadoTurnosService";

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100%'
    },
    btnConfirm: {
        marginTop: "1rem",
        textTransform:"none"
    },
    title: {
        marginTop: -200,
        fontWeight: "bold",
    }
}));
export const AbonarTurnoScreen = () => {
    const dispatch = useDispatch()
    const classes = useStyles()

    const [linkPago, setLinkPago] = React.useState(null)

    const { idAgenda } = useParams()

    useEffect(async () => {
        try {
            dispatch(startSpinner())
            const result = await AfiliadoTurnosService.getLinkPagoTurno(idAgenda)
            const body = await result.json()

            if (result.ok) {
                if(body?.adeudaTurno && body?.linkPago)
                    window.open(body.linkPago,"_self");
                else
                    setLinkPago(body);                
                dispatch(finishSpinner())
            } else {
                throw body.errores
            }
        } catch (error) {            
            dispatch(finishSpinner())
            if (error.mensaje) {
                dispatch(startAlerta(error.mensaje, "error"))
            } else if (error) {
                dispatch(startAlerta(error, "error"))
            } else {
                dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente", "error"))
            }
            console.log("Error al traer los datos del turno", error)
        }
    }, [dispatch, idAgenda])
    
    return (
        <div className={classes.root}>
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                justifyContent="center"
            >
                <Container maxWidth="sm">
                    {(!linkPago || linkPago?.adeudaTurno) &&
                        <Box p="1rem">                        
                            <Typography align="center" variant="h4" className={classes.title} color="secondary">
                                Redirigiendo...
                            </Typography>                        
                        </Box>
                    }
                    {!linkPago?.adeudaTurno &&
                        <Box p="1rem">                        
                            <Typography align="center" variant="h4" className={classes.title} color="secondary">
                                {linkPago?.descripcion}
                            </Typography>                        
                        </Box>
                    }                    
                </Container>
            </Box>
        </div>
    );
};